import React from 'react';
import { Assignment as AssignmentIcon } from '@mui/icons-material';
import CatalogoIdDescripcion, { CatalogoIdDescripcionForm } from './CatalogoIdDescripcion';

export { CatalogoIdDescripcionForm as CatalogoDeclaracionesForm };

/**
 * Catálogo reutilizable de declaraciones (id, descripcion).
 * Diálogo (`open` / `onClose`) o embebido (`embedded`).
 */
const CatalogoDeclaraciones = (props) => (
  <CatalogoIdDescripcion
    titulo="Declaraciones"
    singular="declaración"
    icono={AssignmentIcon}
    listPath="/contabilidadbackend_listardeclaracionfiscal"
    savePath="/contabilidadbackend_guardardeclaracionfiscal"
    deletePath="/contabilidadbackend_eliminardeclaracionfiscal"
    listKey="declaraciones"
    {...props}
  />
);

export default CatalogoDeclaraciones;
